/**
 * Part of edu099 project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

const { onMounted, onUnmounted } = Vue;

export default function mobileCheck(state) {
  const isMobileCheck = () => {
    state.isMobile = window.innerWidth <= 991;
  };

  onMounted(async () => {
    isMobileCheck();
  });

  onMounted(() => window.addEventListener('resize', isMobileCheck));
  onUnmounted(() => window.removeEventListener('resize', isMobileCheck));
}
